"use strict"; // Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var coreutils_1 = require("@jupyterlab/coreutils");

var serverconnection_1 = require("../serverconnection");
/**
 * The url for the lab settings service.
 */


var SERVICE_SETTINGS_URL = 'api/settings';
/**
 * The settings API service manager.
 */

var SettingManager = /*#__PURE__*/function () {
  /**
   * Create a new setting manager.
   */
  function SettingManager() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SettingManager);

    this.serverSettings = options.serverSettings || serverconnection_1.ServerConnection.makeSettings();
  }
  /**
   * Fetch a plugin's settings.
   *
   * @param id - The plugin's ID.
   *
   * @returns A promise that resolves if successful.
   */


  _createClass(SettingManager, [{
    key: "fetch",
    value: function fetch(id) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var serverSettings, baseUrl, pageUrl, _serverconnection_1$S, makeRequest, ResponseError, base, url, response;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                serverSettings = this.serverSettings;
                baseUrl = serverSettings.baseUrl, pageUrl = serverSettings.pageUrl;
                _serverconnection_1$S = serverconnection_1.ServerConnection, makeRequest = _serverconnection_1$S.makeRequest, ResponseError = _serverconnection_1$S.ResponseError;
                base = baseUrl + pageUrl;
                url = Private.url(base, id);
                _context.next = 7;
                return makeRequest(url, {}, serverSettings);

              case 7:
                response = _context.sent;

                if (!(response.status !== 200)) {
                  _context.next = 10;
                  break;
                }

                throw new ResponseError(response);

              case 10:
                return _context.abrupt("return", response.json());

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Save a plugin's settings.
     *
     * @param id - The plugin's ID.
     *
     * @param raw - The user setting values as a raw string of JSON with comments.
     *
     * @returns A promise that resolves if successful.
     */

  }, {
    key: "save",
    value: function save(id, raw) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var serverSettings, baseUrl, pageUrl, _serverconnection_1$S2, makeRequest, ResponseError, base, url, init, response;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                serverSettings = this.serverSettings;
                baseUrl = serverSettings.baseUrl, pageUrl = serverSettings.pageUrl;
                _serverconnection_1$S2 = serverconnection_1.ServerConnection, makeRequest = _serverconnection_1$S2.makeRequest, ResponseError = _serverconnection_1$S2.ResponseError;
                base = baseUrl + pageUrl;
                url = Private.url(base, id);
                init = {
                  body: raw,
                  method: 'PUT'
                };
                _context2.next = 8;
                return makeRequest(url, init, serverSettings);

              case 8:
                response = _context2.sent;

                if (!(response.status !== 204)) {
                  _context2.next = 11;
                  break;
                }

                throw new ResponseError(response);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return SettingManager;
}();

exports.SettingManager = SettingManager;
/**
 * A namespace for private data.
 */

var Private;

(function (Private) {
  /**
   * Get the url for a plugin's settings.
   */
  function url(base, id) {
    return coreutils_1.URLExt.join(base, SERVICE_SETTINGS_URL, id);
  }

  Private.url = url;
})(Private || (Private = {}));